export default {
    pinMamagement: 'การจัดการรหัส',
    searchBy: 'ค้นหาตามรหัสพนักงานหรือชื่อ',
    search: 'ค้นหา',
    name: 'ชื่อ - นามสกุล',
    employeeNo: 'รหัสพนักงาน',
    pinStatus: 'สถานะรหัส PIN',
    reset: 'รีเซ็ท'
}
